import styled from 'styled-components';

export const CrossSellsContainer = styled.div`
  margin: 20px 0 40px;
  text-align: left;

  html[dir='rtl'] & {
    text-align: right;
  }
`;

export const CrossSellList = styled.div`
  display: flex;
  white-space: nowrap;
  scroll-snap-type: x mandatory;
  overflow: auto;
`;

export const SliderItem = styled.div`
  display: inline-block;
  margin-right: 10px;
  white-space: normal;
  scroll-snap-align: start;
  flex: 1;
  max-width: 50%;

  html[dir='rtl'] & {
    margin-right: 0;
    margin-left: 10px;
  }
`;
